﻿import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RestService {
    constructor(private http: HttpClient) { }

    getAll(endPoint: string): Observable<any[]> {
        return this.http.get<any[]>(endPoint);
    }

    get(endPoint: string): Observable<any> {
        return this.http.get<any>(endPoint);
    }

    getParam(clave: string): Observable<any> {
        return this.http.get<any>('/rest-api/public/parametro/' + clave);
    }


    post(endPoint: string, object: any): Observable<any> {
        return this.http.post<any>(endPoint, object);
    }

}
